import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/page";
import { images } from "../data/offer";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer: number;
    const schedule = (delay: number) => {
      timer = window.setTimeout(() => {
        setBuyerIndex(prev => {
          let next = Math.floor(Math.random() * buyers.length);
          if (next === prev) next = (next + 1) % buyers.length;
          return next;
        });
        setMinutesAgo(1 + Math.floor(Math.random() * 14));
        setVisible(true);
        timer = window.setTimeout(() => {
          setVisible(false);
          schedule(GAP);
        }, VISIBLE_FOR);
      }, delay);
    };
    schedule(FIRST_DELAY);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  const buyer = buyers[buyerIndex];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-28 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-274" data-mp="1fv0qno9ofevk">
      <AnimatePresence data-id="element-275" data-mp="n6v6p3qg5tws">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-xl ring-1 ring-navy-900/10 sm:w-80" data-id="element-276" data-mp="n7dbwpv37igu">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-surface object-contain" data-id="element-277" data-mp="23kld4h51gu9l" />
            <div className="min-w-0" data-id="element-278" data-mp="2ao1mavp2hlop">
              <p className="text-sm leading-snug text-ink" data-id="element-279" data-mp="2fnnyr2x2mxwg">
                <strong data-id="element-280" data-mp="2fm365iubhp18">{buyer.name}</strong> from <strong data-id="element-281" data-mp="2kmr6iv4fri84">{buyer.country}</strong> just purchased the Blueprint™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-ink-soft" data-id="element-282" data-mp="2kkwhp5q1n5yr">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-success" aria-hidden="true" data-id="element-283" data-mp="2pjrcl61ackz8" />
                {minutesAgo} {minutesAgo === 1 ? "minute" : "minutes"} ago · Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-ink-soft transition-colors duration-150 ease-out hover:bg-surface hover:text-ink" data-id="element-284" data-mp="21w9gwzewh2qz">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-285" data-mp="1e6f76qpvnuay" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}